/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SortDirection {
    ASCENDING = 'Ascending',
    DESCENDING = 'Descending',
}